export const getLanguage = () => 'es'//document.querySelector('html')?.getAttribute('lang') || 'es'
export const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const parseLocalDate = (
  dateString: string,
  lang = getLanguage(),
  timeZone = getTimeZone(),
  options: DateFormatOptions = {hours: true, minutes: true, seconds: true, millis: false}
) => {
//   if (!dateString) return ''
//   return new Date(dateString).toLocaleString(lang, {timeZone})
    if (!dateString) return ''
    const date = new Date(dateString) //.toLocaleString(lang, {timeZone})
    if (options.hours && options.minutes && options.seconds && options.millis) {
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${padMilliseconds(
            date.getMilliseconds()
        )}Z`
    } else if (options.hours && options.minutes && options.seconds) {
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    } else if (options.hours && options.minutes) {
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}`
    } else if (options.hours) {
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
            date.getHours()
        )}`
    } 
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
export const pad = (n: number) => String(n).padStart(2, '0')
export const padMilliseconds = (n: number) => String(n).padStart(3, '0')
export const formatDate = (date?: Date): string => {
    if (!date) return ''
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
      date.getHours()
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${padMilliseconds(date.getMilliseconds())}Z`
}

export interface DateFormatOptions {
  hours: boolean,
  minutes: boolean,
  seconds: boolean,
  millis: boolean,
}

export const parseDate = (
  dateString: string,
  lang = getLanguage(),
  timeZone = getTimeZone(),
  options: DateFormatOptions = { hours: true, minutes: true, seconds: true, millis: false }
) => {
  if (!dateString) return ''
  const date = new Date(dateString)//.toLocaleString(lang, {timeZone})
  if (options.hours && options.minutes && options.seconds && options.millis) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
      date.getHours()
    )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${padMilliseconds(
      date.getMilliseconds()
    )}Z`
  } else if (options.hours && options.minutes && options.seconds) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
      date.getHours()
    )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  } else if (options.hours && options.minutes) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
      date.getHours()
    )}:${pad(date.getMinutes())}`
  } else if (options.hours) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
      date.getHours()
    )}`
  } 
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}